
import './App.css';
import { Show } from './connections/Show';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import { Route, Routes } from 'react-router-dom';
import Staff from './pages/Staff';
import Customer from './pages/Customer';
import Spares from './pages/Spares';
import Services from './pages/Services';
import Navbar from './pages/Navbar';
import Spare_log from './pages/Spare_log';
import Estimate_data from './pages/Estimate_data';
import Service_log from './pages/Service_log';
import Branch from './pages/Branch';
import Insurance from './pages/Insurance';
import Job_card from './pages/Job_card';
import { useState } from 'react';
import Vendor from './pages/Vendor';
import Purchase from './pages/Purchase';
import Spare_log_admin from './pages/Spare_log_admin';
import Spare_requests from './pages/Spare_requests';
import Sales from './pages/Sales';
import Brands_models from './pages/Brands_models';
import Report from './pages/Report';
import ExpenseCategory from './pages/expense_category';
import Expenses from './pages/Expenses';
import Income from './pages/Income';
import IncomeCategory from './pages/income_category';
import Payment from './pages/Payment';
import Insurance_type from './pages/Insurance_type';
import RolesCrud from './pages/Roles';
import Complete_service from './pages/Complete_service';
import { Advance } from './pages/Advance';
import { VendorAdvance } from './pages/VendorAdvance';
function App() {
  const [theme, setTheme] = useState("light");
  return (
    <div className="App">
      <Show className="relative">
        <Navbar setTheme={setTheme} theme={theme}/>
        
      </Show>
      <Routes>
        <Route path="/" element={<Login theme={theme}/>} />
        <Route path="/staff" element={<Staff theme={theme}/>} />
        <Route path="/staffrole" element={<RolesCrud theme={theme}/>} />
        <Route path="/customer" element={<Customer theme={theme}/>} />
        <Route path="/spares" element={<Spares theme={theme}/>} />
        <Route path="/services" element={<Services theme={theme}/>} />
        <Route path="/spare/log" element={<Spare_log theme={theme}/>} />
        <Route path="/estimate_data" element={<Estimate_data theme={theme}/>} />
        <Route path="/service_log" element={<Service_log theme={theme}/>} />
        <Route path="/branch" element={<Branch theme={theme}/>} />
        <Route path="/insurance" element={<Insurance theme={theme}/>} />
        <Route path="/job_card" element={<Job_card theme={theme}/>} />
        <Route path="/vendor" element={<Vendor theme={theme}/>} />
        <Route path="/purchase" element={<Purchase theme={theme}/>} />
        <Route path="/spare_log_admin" element={<Spare_log_admin theme={theme}/>} />
        <Route path="/spare_request" element={<Spare_requests theme={theme}/>} />
        <Route path="/sales" element={<Sales theme={theme}/>} />
        <Route path="/dashboard" element={<Dashboard theme={theme}/>} />
        <Route path="/brand" element={<Brands_models theme={theme}/>} />

        <Route path="/expense" element={<Expenses theme={theme}/>} />
        <Route path="/income" element={<Income theme={theme}/>} />

        <Route path="/report" element={<Report theme={theme}/>} />

        <Route path="/expense_category" element={<ExpenseCategory theme={theme}/>} />
        <Route path="/income_category" element={<IncomeCategory theme={theme}/>} />

        <Route path="/payment" element={<Payment theme={theme}/>} />
        <Route path="/insurance_type" element={<Insurance_type theme={theme}/>} />
        <Route path="/advance" element={<Advance theme={theme}/>} />


        <Route path="/complete_service" element={<Complete_service theme={theme}/>} />
        <Route path="/vendor_advance" element={<VendorAdvance theme={theme}/>} />

      </Routes>
    </div>
  );
}

export default App;
